<span class="label" #labelRef [class.label--hidden]="!!options.hideTitle">
  <ng-content />
</span>
@if (vm$ | async; as vm) {
  <div
    class="filepicker"
    [class.filepicker--errors]="hasDownloadError"
    [class.filepicker--image-preview]="vm.canPreviewImage"
  >
    @if (vm.uploadStep === UploadStep.Waiting && !isDisabled) {
      <app-file-picker-placeholder
        class="placeholder"
        [id]="id + '__placeholder'"
        [accept]="options.acceptedFormats!"
        [maxSizePerFileInMB]="options.maxSizePerFileInMB!"
        [caption]="options.caption"
        [multiUpload]="options.multiUpload!"
        [height]="options.requiredSize?.height"
        [width]="options.requiredSize?.width"
        (filesChosen)="onFilesChosen($event)"
        (rejectedFilesCount)="rejectedFileCount = $event"
      />
    }
    @if (vm.uploadStep === UploadStep.Uploading || vm.uploadStep === UploadStep.Ready) {
      @if (vm.previewImageUrl && !options.multiUpload && !isDisabled) {
        <app-file-actions
          [fileSrc]="vm.previewImageUrl"
          [isDownloadable]="!!vm.previewImageUrl"
          (fileCancelled)="onFileCancelled(0)"
        />
      }
      @if (vm.canPreviewImage) {
        <figure class="file-upload__preview">
          <img
            class="file-upload__preview__image"
            #previewImage
            [class.file-upload__preview__image--svg]="isPreviewImageSvg"
            [src]="vm.previewImageUrl"
            [alt]="filesControls[0].value"
            (onerror)="onPreviewImageError()"
          />
          @if (!options.hideCaption) {
            <figcaption class="file-upload__preview__legend">
              {{ filesControls[0].value }}
            </figcaption>
          }
        </figure>
      }
      <div class="file-upload__drop-zone">
        @if (!isUploading && !hasDownloadError) {
          <input
            class="file-input"
            [attr.id]="id + '__input'"
            [accept]="computedAccept"
            (change)="onFilesInput($event)"
            tabindex="-1"
            multiple
            type="file"
          />
        }
        @if (isUploading) {
          <div class="file-upload__drop-zone__spinner">
            <app-file-picker-spinner
              [progress]="globalProgress"
              [diameter]="48"
              [strokeWidth]="4"
              [ariaLabel]="'Fichiers chargés à ' + globalProgress + '%'"
            />
          </div>
        }
        @if (!isUploading) {
          <div class="file-upload__drop-zone__icon">
            @if (!hasDownloadError) {
              <svg width="65" height="61" viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  opacity="0.3"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.71429 2H24.0221C24.3768 2 24.72 2.12568 24.9908 2.35474L35.4687 11.2173C35.8057 11.5023 36 11.9212 36 12.3625V38.1667C36 41.7478 35.9591 42 32.2857 42H9.71429C6.0409 42 6 41.7478 6 38.1667V5.83333C6 2.25225 6.0409 2 9.71429 2ZM14 25C14 24.4477 14.4477 24 15 24H31C31.5523 24 32 24.4477 32 25V27C32 27.5523 31.5523 28 31 28H15C14.4477 28 14 27.5523 14 27V25ZM15 32C14.4477 32 14 32.4477 14 33V35C14 35.5523 14.4477 36 15 36H23C23.5523 36 24 35.5523 24 35V33C24 32.4477 23.5523 32 23 32H15Z"
                  fill="#FC5A5A"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.7143 6H30.0221C30.3768 6 30.72 6.12568 30.9908 6.35474L41.4687 15.2173C41.8057 15.5023 42 15.9212 42 16.3625V42.1667C42 45.7478 41.9591 46 38.2857 46H13.7143C10.0409 46 10 45.7478 10 42.1667V9.83333C10 6.25225 10.0409 6 13.7143 6ZM14 25C14 24.4477 14.4477 24 15 24H31C31.5523 24 32 24.4477 32 25V27C32 27.5523 31.5523 28 31 28H15C14.4477 28 14 27.5523 14 27V25ZM15 32C14.4477 32 14 32.4477 14 33V35C14 35.5523 14.4477 36 15 36H23C23.5523 36 24 35.5523 24 35V33C24 32.4477 23.5523 32 23 32H15Z"
                  fill="#4B45B2"
                />
                @if (options.multiUpload) {
                  <g filter="url(#shadowFilter)">
                    <rect x="27" y="31" width="30" height="30" rx="10" fill="#ffffff" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M49 44.9504H43V38.9774C43 38.4269 42.552 37.9819 42 37.9819C41.448 37.9819 41 38.4269 41 38.9774V44.9504H35C34.448 44.9504 34 45.3954 34 45.9459C34 46.4964 34.448 46.9414 35 46.9414H41V52.9144C41 53.4649 41.448 53.9099 42 53.9099C42.552 53.9099 43 53.4649 43 52.9144V46.9414H49C49.552 46.9414 50 46.4964 50 45.9459C50 45.3954 49.552 44.9504 49 44.9504"
                      fill="#4B45B2"
                    />
                  </g>
                }
                <defs>
                  <filter
                    id="shadowFilter"
                    x="19"
                    y="27"
                    width="46"
                    height="46"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="4" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1085_1545" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1085_1545" result="shape" />
                  </filter>
                </defs>
              </svg>
            }
            @if (hasDownloadError) {
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_213_1904)">
                  <path
                    d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
                    fill="#FFCFD5"
                  />
                  <path
                    d="M32.6996 26.586L31.0341 25.7533C30.7999 25.6361 30.5234 25.6361 30.2892 25.7533L27.3307 27.2325L24.3723 25.7533C24.1381 25.6361 23.8616 25.6361 23.6274 25.7533L20.6689 27.2325L17.7105 25.7533C17.4763 25.6361 17.1997 25.6361 16.9655 25.7533L15.3001 26.586C15.0187 26.7275 14.8398 27.0154 14.8398 27.3308V37.3235C14.8398 37.7838 15.2123 38.1562 15.6725 38.1562H32.3269C32.7873 38.1562 33.1596 37.7837 33.1596 37.3235V27.3308C33.1599 27.0154 32.981 26.7275 32.6996 26.586ZM32.3271 9.84375H21.5018V15.6727C21.5018 16.1331 21.1293 16.5054 20.6691 16.5054H14.84V23.1672C14.84 23.4559 14.9897 23.7234 15.2353 23.8755C15.4776 24.0267 15.7866 24.0406 16.0452 23.9121L17.3382 23.2656L20.2967 24.7448C20.5308 24.8618 20.8074 24.8618 21.0416 24.7448L24 23.2657L26.9584 24.7448C27.1926 24.8619 27.4693 24.8618 27.7034 24.7448L30.6618 23.2657L31.9549 23.9122C32.2134 24.0414 32.5208 24.0268 32.7648 23.8756C33.0104 23.7235 33.16 23.456 33.16 23.1673V10.6764C33.1599 10.2162 32.7874 9.84375 32.3271 9.84375ZM19.8363 10.3317L15.3279 14.8401H19.8363V10.3317Z"
                    fill="#FC5A5A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_213_1904">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            }
          </div>
        }
      </div>
      <ul class="file-upload__file-list">
        @for (control of filesControls; track $index; let index = $index) {
          <li class="file-uploader-container">
            <app-file-picker-uploader
              [formControl]="control"
              [options]="options"
              (fileCancelled)="onFileCancelled(index)"
            />
          </li>
        }
      </ul>
    }
  </div>
}

@if (options.maxSizePerFileInMB || options.requiredSize) {
  <!-- ng-container keeps the block indentation out of the separators -->
  <p class="size" [class.size--error]="hasErrors">
    @if (minimumSizeLabel) {
      {{ minimumSizeLabel }}
    }
    @if (minimumSizeLabel && options.maxSizePerFileInMB) {
      <ng-container>&nbsp;/&nbsp;</ng-container>
    }
    @if (options.maxSizePerFileInMB) {
      <ng-container>{{ fileMaxWeightLabel }}</ng-container>
    }
    @if (options.maxSizePerFileInMB && options.requiredSize) {
      <ng-container>&nbsp;-&nbsp;</ng-container>
    }
    @if (options.requiredSize) {
      <ng-container>{{ fileSizeLabel }}</ng-container>
    }
  </p>
}
